var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from "../../index";
var Animater = /** @class */ (function () {
    function Animater() {
        this._duration = 250;
        this._display = 'block';
        this.delays = new Map();
    }
    Animater.prototype.toggleClass = function (element, toRemove, toAdd) {
        element.classList.remove(toRemove);
        element.classList.add(toAdd);
    };
    Animater.prototype.withDuration = function (duration) {
        this._duration = duration;
        return this;
    };
    Animater.prototype.withDisplay = function (display) {
        this._display = display;
        return this;
    };
    Animater.prototype.fadeToggle = function (element) {
        if (!element) {
            return;
        }
        var computedStyle = getComputedStyle(element);
        if (computedStyle.opacity === '0' || computedStyle.display === 'none' || element.classList.contains('animator__fade-out')) {
            this.fadeIn(element);
        }
        else {
            this.fadeOut(element);
        }
    };
    Animater.prototype.slideToggle = function (element) {
        if (!element) {
            return;
        }
        var computedStyle = getComputedStyle(element);
        if (computedStyle.display === 'none' || element.classList.contains('animator__slide-up')) {
            this.slideIn(element);
        }
        else {
            this.slideOut(element);
        }
    };
    Animater.prototype.fadeIn = function (element) {
        if (!element) {
            return;
        }
        clearTimeout(this.delays.get(element));
        this.toggleClass(element, 'animator__fade-out', 'animator__fade-in');
        element.style.opacity = '0';
        element.style.display = this._display;
        element.style.transition = "opacity ".concat(this._duration, "ms ease-in-out");
        this.delays.set(element, setTimeout(function () {
            element.style.opacity = '1';
        }, 0));
    };
    Animater.prototype.fadeOut = function (element) {
        if (!element) {
            return;
        }
        clearTimeout(this.delays.get(element));
        this.toggleClass(element, 'animator__fade-in', 'animator__fade-out');
        element.style.transition = "opacity ".concat(this._duration, "ms ease-in-out");
        element.style.opacity = '0';
        this.delays.set(element, setTimeout(function () {
            element.style.display = 'none';
        }, this._duration));
    };
    Animater.prototype.slideIn = function (element) {
        if (!element) {
            return;
        }
        clearTimeout(this.delays.get(element));
        this.toggleClass(element, 'animator__slide-up', 'animator__slide-down');
        element.style.height = '0';
        element.style.display = this._display;
        element.style.transition = "height ".concat(this._duration, "ms ease-in-out");
        element.style.overflow = 'hidden';
        setTimeout(function () {
            element.style.height = "".concat(element.scrollHeight, "px");
        }, 0);
        this.delays.set(element, setTimeout(function () {
            element.style.height = null;
        }, this._duration));
    };
    Animater.prototype.slideOut = function (element) {
        if (!element) {
            return;
        }
        clearTimeout(this.delays.get(element));
        this.toggleClass(element, 'animator__slide-down', 'animator__slide-up');
        element.style.height = "".concat(element.scrollHeight, "px");
        element.style.transition = "height ".concat(this._duration, "ms ease-in-out");
        setTimeout(function () {
            element.style.height = '0';
        }, 0);
        this.delays.set(element, setTimeout(function () {
            element.style.display = 'none';
            element.style.overflow = null;
        }, this._duration));
    };
    Animater = __decorate([
        Injectable()
    ], Animater);
    return Animater;
}());
export default Animater;
//# sourceMappingURL=animate.js.map